<template>
  <div class="fullbox">
    <div class="fullbox_top">随手拍月度汇总数据</div>
    <div class="fullbox_table fullbox_table1" v-loading="loading">
      <pcTable :tableData="tableSaleAll" />
    </div>
  </div>
</template>

<script>
import apis from "@/apis/photoCasually";
import pcTable from "./table.vue";
import moment from "moment";
// import moment from "moment";
export default {
  name: "causallyPush",
  components: {
    pcTable,
  },
  data() {
    return {
      tableSaleAll: [],
      loading: false,
      id: "",
    };
  },
  computed: {},
  mounted() {
    const { id } = this.$route.query;
    this.id = id;
    this.getTableTypeAll();
    // this.loading = true;
    // setTimeout(() => {
    //   const userId = sessionStorage.getItem("userId");
    //   if (!userId) {
    //     let timer = null;
    //     timer = setInterval(() => {
    //       this.getTableTypeAll();
    //       this.getSelectShow()
    //       if (this.userId) {
    //         clearInterval(timer);
    //       }
    //     }, 500);
    //   } else {
    //     this.getTableTypeAll();
    //     this.getSelectShow()
    //   }
    // }, 700);
    // if (id) {
    //   this.urlId = id;
    //   this.getReadTask();
    // }

    // this.loading = true;
    // setTimeout(() => {
    //   this.token = sessionStorage.userAuth;
    //   this.getTableTypeAll();
    // }, 500);
  },
  methods: {
    // 获取列表
    getTableTypeAll() {
      this.loading = true;
      apis
        .getSummarize({
          id: this.id,
        })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.tableSaleAll = [res.data];
            this.tableSaleAll.length > 0 &&
              this.tableSaleAll.forEach((item) => {
                item.date = `${item.year}-${moment()
                  .month(item.month - 1)
                  .format("MM")}`;
              });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fullbox {
  background: #fff;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  text-align: center;
  padding-bottom: 50px;
  position: relative;
  .fullbox_top {
    font-size: 44px;
    padding: 100px 0 50px;
  }
  .fullbox_search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // justify-content: center;
    .data-switch {
      display: flex;
      .data-type {
        width: 175px;
        height: 70px;
        background: #ffffff;
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.19);
        font-size: 32px;
        font-weight: 400;
        line-height: 70px;
        text-align: center;
        color: #3d3d3d;
        cursor: pointer;

        &.monthly {
          border-radius: 36px 0 0 36px;
        }
        &.realtime {
          border-radius: 0 36px 36px 0;
          // margin-right: 10px;
        }

        &.active {
          font-weight: bold;
          background: #018755;
          box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.19);
          color: #fff;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .fullbox_table {
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 50px;
      margin-left: 5%;
    }
    .fullbox_search {
      padding: 0 50px 0;
      // position: absolute;
      // top: 4.3%;
      // right: 2%;
      ::v-deep {
        .el-date-editor {
          height: 40px;
          width: 140px;
        }
        .el-input__inner {
          height: 40px;
          width: 140px;
        }
      }
    }
    .fullbox_time {
      font-size: 36px;
      // margin-right: 100px;
    }
  }
  @media screen and (min-width: 600px) {
    .fullbox_table {
      width: 70%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 50px;
      margin-left: 15%;
    }
    .fullbox_table2 {
      width: 90%;
      margin-left: 5%;
    }
    .fullbox_search {
      padding: 0 15% 0;
      // position: absolute;
      // top: 3%;
      // right: 25%;
      ::v-deep {
        .el-date-editor {
          height: 40px;
          width: 140px;
        }
        .el-input__inner {
          height: 40px;
          width: 140px;
        }
      }
    }
  }
  // .fullbox_table {
  //   width: 100%;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   margin-top: 30px;
  //   // margin-left: 25%;
  // }
  ::v-deep {
    .fullbox_table1 {
      .el-table {
        font-size: 17px;
        .cell {
          color: #000;
        }
      }
    }
  }
}
</style>
